var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"step",class:{ active: _vm.active }},[_c('div',{staticClass:"step__wrapper"},[_c('div',{staticClass:"step__wrapper__row"},[_c('i',{staticClass:"dot"}),_c('div',{staticClass:"step__content"},[_vm._t("default")],2)]),_c('div',{staticClass:"line"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }